module.exports = __webpack_public_path__ + "img/mm-howto-cn.0eccbebe.png";